import { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

interface Props {
    children: ReactNode;
    variant?: 'promo' | 'danger' | 'warning' | 'success' | 'neutral' | 'suggestion' | 'outline';
}

export function Tag({ variant = 'promo', children }: Props) {
    return (
        <span className="inline-flex items-center">
            &zwnj;
            <span
                className={twJoin(
                    'inline-flex max-h-fit items-center justify-center text-nowrap rounded-full border px-3 py-px text-xs font-medium leading-5',
                    variant === 'promo' && 'border-red-500 bg-red-500 text-white',
                    variant === 'warning' && 'border-yellow-300 bg-yellow-100 text-yellow-600',
                    variant === 'danger' && 'border-orange-300 bg-orange-100 text-orange-500',
                    variant === 'success' && 'border-primary-250 bg-primary-100 text-green-600',
                    variant === 'neutral' && 'border-neutral-150 bg-neutral-100 text-neutral-500',
                    variant === 'suggestion' && 'rounded-md border-0 bg-primary-300',
                    variant === 'outline' && 'border-neutral-150 bg-white text-neutral-500',
                )}>
                {children}
            </span>
        </span>
    );
}
